import { useUser } from 'hooks/useUser'
import { sendConversionToSlack } from 'utils/slack'
import fbq from 'hooks/useFacebookPixel'
import twq from 'hooks/useXPixel'

export const tracking = {
    eventTrack: function (eventCategory, eventName, eventLabel) {
        if (typeof window !== `undefined`) {
            const trackingEventOptions = {
                event_action: eventName,
                event_category: eventCategory,
                event_label: eventLabel,
            }
            if (window.gtag) {
                window.gtag('event', eventName, trackingEventOptions)
            }
        }
    },
    trackConversion(type, metadata, user) {
        const options = {}
        let linkedinConversionId
        let facebookConversionId
        let xConversionId
        const {
            firstName,
            lastName,
            website,
            github,
            linkedin,
            twitter,
            biography,
            id,
            email,
            companyName,
            companySize,
            country,
            phone,
            totalApartments,
        } = user?.profile || {}

        switch (type) {
            case 'free_trial':
                options.send_to = process.env.GATSBY_GOOGLE_FREE_TRIAL_CONVERSION_ID
                linkedinConversionId = process.env.GATSBY_LINKEDIN_FREE_TRIAL_CONVERSION_ID
                facebookConversionId = process.env.GATSBY_FACEBOOK_FREE_TRIAL_CONVERSION_ID
                xConversionId = process.env.GATSBY_X_FREE_TRIAL_CONVERSION_ID
                break
            case 'contact_us':
                options.send_to = process.env.GATSBY_GOOGLE_CONTACT_US_CONVERSION_ID
                linkedinConversionId = process.env.GATSBY_LINKEDIN_CONTACT_US_CONVERSION_ID
                facebookConversionId = process.env.GATSBY_FACEBOOK_CONTACT_US_CONVERSION_ID
                xConversionId = process.env.GATSBY_X_CONTACT_US_CONVERSION_ID
                break
            case 'request_meeting':
                options.send_to = process.env.GATSBY_GOOGLE_REQUEST_MEETING_CONVERSION_ID
                linkedinConversionId = process.env.GATSBY_LINKEDIN_REQUEST_MEETING_CONVERSION_ID
                facebookConversionId = process.env.GATSBY_FACEBOOK_REQUEST_MEETING_CONVERSION_ID
                xConversionId = process.env.GATSBY_X_REQUEST_MEETING_CONVERSION_ID
                break
        }
        const trackOptions = user
            ? {
                  userEmail: email,
                  firstName: firstName,
                  lastName: lastName,
                  companyName: companyName,
                  companySize: companySize,
                  country: country,
                  phone: phone,
                  totalApartments: totalApartments,
              }
            : 'anonymous user email'

        // linkedin
        if (typeof window !== `undefined` && window.lintrk) {
            window.lintrk('track', { conversion_id: linkedinConversionId })
        }
        //segment
        if (typeof window !== `undefined` && window.analytics) {
            window.analytics.track(type, trackOptions)
        }
        //posthog

        // if (typeof window !== `undefined` && window.posthog) {
        //     window.posthog.capture(type, trackOptions)
        // }

        //facebook
        if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('trackCustom', type)
            //window.fbq('trackCustom', facebookConversionId)
        }

        // console.log('Firing X Conversion event')
        if (typeof window !== 'undefined' && window.twq) {
            // console.log('twq FOUND')
            // console.log(`Firing X conversion event of type: ${type}`)
            try {
                // event for x
                window.twq('event', xConversionId)
                // console.log('X conversion event fired')
            } catch (error) {
                console.error('Error while firing twq event:', error)
            }
        } else {
            console.warn('twq not found')
        }

        // console.log('Firing Gtag Conversion event')
        if (typeof window !== 'undefined' && window.gtag) {
            // console.log('GTAG FOUND')
            // console.log(`Firing conversion event of type: ${type}`)
            // console.log('Options for gtag:', options)

            try {
                // event for google ads
                window.gtag('event', 'conversion', options)
                // console.log('Google Ads conversion event fired')

                // event for google analytics
                window.gtag('event', type, options)
                // console.log('Google Analytics conversion event fired')
            } catch (error) {
                console.error('Error while firing gtag event:', error)
            }
        } else {
            console.warn('Gtag not found')
        }

        if (process.env.GATSBY_CONVERSION_TO_SLACK) {
            sendConversionToSlack(type, metadata, user)
        }
    },
    testTrackConversion: function (type, metadata, user) {
        console.log(`type ${type} metadata ${JSON.stringify(metadata)} user ${JSON.stringify(user)}`)
    },
}

export default tracking
